import _regeneratorRuntime from "E:\\monday-web\\node_modules\\@babel\\runtime\\regenerator\\index.js";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { createCanvas } from "canvas";
import { decompressFrames, parseGIF } from "./gifuct-js/index";
import { QRCodeModel, QRErrorCorrectLevel, QRUtil } from "./qrcode";
import GIFEncoder from "./gif.js/GIFEncoder";
var defaultScale = 0.4;

function loadImage(url) {
  if (!url) {
    return undefined;
  }

  function cleanup(img) {
    img.onload = null;
    img.onerror = null;
  }

  return new Promise(function (resolve, reject) {
    if (url.slice(0, 4) == 'data') {
      var _img = new Image();

      _img.onload = function () {
        resolve(_img);
        cleanup(_img);
      };

      _img.onerror = function () {
        reject('Image load error');
        cleanup(_img);
      };

      _img.src = url;
      return;
    }

    var img = new Image();
    img.setAttribute("crossOrigin", 'Anonymous');

    img.onload = function () {
      resolve(img);
    };

    img.onerror = function () {
      reject('Image load error');
    };

    img.src = url;
  });
}

export var AwesomeQR = /*#__PURE__*/function () {
  function AwesomeQR(options) {
    _classCallCheck(this, AwesomeQR);

    var _options = Object.assign({}, options);

    Object.keys(AwesomeQR.defaultOptions).forEach(function (k) {
      if (!(k in _options)) {
        Object.defineProperty(_options, k, {
          value: AwesomeQR.defaultOptions[k],
          enumerable: true,
          writable: true
        });
      }
    });

    if (!_options.components) {
      _options.components = AwesomeQR.defaultComponentOptions;
    } else if (_typeof(_options.components) === "object") {
      Object.keys(AwesomeQR.defaultComponentOptions).forEach(function (k) {
        if (!(k in _options.components)) {
          Object.defineProperty(_options.components, k, {
            value: AwesomeQR.defaultComponentOptions[k],
            enumerable: true,
            writable: true
          });
        } else {
          Object.defineProperty(_options.components, k, {
            value: Object.assign(Object.assign({}, AwesomeQR.defaultComponentOptions[k]), _options.components[k]),
            enumerable: true,
            writable: true
          });
        }
      });
    }

    if (_options.dotScale !== null && _options.dotScale !== undefined) {
      if (_options.dotScale <= 0 || _options.dotScale > 1) {
        throw new Error("dotScale should be in range (0, 1].");
      }

      _options.components.data.scale = _options.dotScale;
      _options.components.timing.scale = _options.dotScale;
      _options.components.alignment.scale = _options.dotScale;
    }

    this.options = _options;
    this.canvas = createCanvas(options.size, options.size);
    this.canvasContext = this.canvas.getContext("2d");
    this.qrCode = new QRCodeModel(-1, this.options.correctLevel);

    if (Number.isInteger(this.options.maskPattern)) {
      this.qrCode.maskPattern = this.options.maskPattern;
    }

    if (Number.isInteger(this.options.version)) {
      this.qrCode.typeNumber = this.options.version;
    }

    this.qrCode.addData(this.options.text);
    this.qrCode.make();
  }

  _createClass(AwesomeQR, [{
    key: "draw",
    value: function draw() {
      var _this = this;

      return new Promise(function (resolve) {
        return _this._draw().then(resolve);
      });
    }
  }, {
    key: "_clear",
    value: function _clear() {
      this.canvasContext.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
  }, {
    key: "_draw",
    value: function _draw() {
      var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u;

      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var nCount, rawSize, rawMargin, margin, rawViewportSize, whiteMargin, backgroundDimming, nSize, viewportSize, size, mainCanvas, mainCanvasContext, backgroundCanvas, backgroundCanvasContext, parsedGIFBackground, gifFrames, gif, r, g, b, count, i, c, backgroundImage, avgRGB, alignmentPatternCenters, dataScale, dataXyOffset, row, col, bIsDark, isBlkPosCtr, isTiming, isProtected, _i, nLeft, nTop, inAgnRange, cornerAlignmentCenter, protectorStyle, _i2, j, agnX, agnY, timingScale, timingXyOffset, _i3, cornerAlignmentScale, cornerAlignmentXyOffset, alignmentScale, alignmentXyOffset, _i4, _j2, _agnX, _agnY, logoImage, logoScale, logoMargin, logoCornerRadius, logoSize, x, y, oldGlobalCompositeOperation, gifOutput, _backgroundCanvas, _backgroundCanvasContext, patchCanvas, patchCanvasContext, patchData, u8array, binary, outCanvas, outCanvasContext;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                nCount = (_a = this.qrCode) === null || _a === void 0 ? void 0 : _a.moduleCount;
                rawSize = this.options.size;
                rawMargin = this.options.margin;

                if (rawMargin < 0 || rawMargin * 2 >= rawSize) {
                  rawMargin = 0;
                }

                margin = Math.ceil(rawMargin);
                rawViewportSize = rawSize - 2 * rawMargin;
                whiteMargin = this.options.whiteMargin;
                backgroundDimming = this.options.backgroundDimming;
                nSize = Math.ceil(rawViewportSize / nCount);
                viewportSize = nSize * nCount;
                size = viewportSize + 2 * margin;
                mainCanvas = createCanvas(size, size);
                mainCanvasContext = mainCanvas.getContext("2d");

                this._clear(); // Translate to make the top and left margins off the viewport


                mainCanvasContext.save();
                mainCanvasContext.translate(margin, margin);
                backgroundCanvas = createCanvas(size, size);
                backgroundCanvasContext = backgroundCanvas.getContext("2d");
                parsedGIFBackground = null;
                gifFrames = [];

                if (!this.options.gifBackground) {
                  _context.next = 47;
                  break;
                }

                gif = parseGIF(this.options.gifBackground);
                parsedGIFBackground = gif;
                gifFrames = decompressFrames(gif, true);

                if (!this.options.autoColor) {
                  _context.next = 45;
                  break;
                }

                r = 0, g = 0, b = 0;
                count = 0;
                i = 0;

              case 28:
                if (!(i < gifFrames[0].colorTable.length)) {
                  _context.next = 41;
                  break;
                }

                c = gifFrames[0].colorTable[i];

                if (!(c[0] > 200 || c[1] > 200 || c[2] > 200)) {
                  _context.next = 32;
                  break;
                }

                return _context.abrupt("continue", 38);

              case 32:
                if (!(c[0] === 0 && c[1] === 0 && c[2] === 0)) {
                  _context.next = 34;
                  break;
                }

                return _context.abrupt("continue", 38);

              case 34:
                count++;
                r += c[0];
                g += c[1];
                b += c[2];

              case 38:
                i++;
                _context.next = 28;
                break;

              case 41:
                r = ~~(r / count);
                g = ~~(g / count);
                b = ~~(b / count);
                this.options.colorDark = "rgb(".concat(r, ",").concat(g, ",").concat(b, ")");

              case 45:
                _context.next = 61;
                break;

              case 47:
                if (!this.options.backgroundImage) {
                  _context.next = 58;
                  break;
                }

                _context.next = 50;
                return loadImage(this.options.backgroundImage);

              case 50:
                backgroundImage = _context.sent;

                if (this.options.autoColor) {
                  avgRGB = AwesomeQR._getAverageRGB(backgroundImage);
                  this.options.colorDark = "rgb(".concat(avgRGB.r, ",").concat(avgRGB.g, ",").concat(avgRGB.b, ")");
                }

                backgroundCanvasContext.drawImage(backgroundImage, 0, 0, backgroundImage.width, backgroundImage.height, 0, 0, size, size);
                backgroundCanvasContext.rect(0, 0, size, size);
                backgroundCanvasContext.fillStyle = backgroundDimming;
                backgroundCanvasContext.fill();
                _context.next = 61;
                break;

              case 58:
                backgroundCanvasContext.rect(0, 0, size, size);
                backgroundCanvasContext.fillStyle = this.options.colorLight;
                backgroundCanvasContext.fill();

              case 61:
                alignmentPatternCenters = QRUtil.getPatternPosition(this.qrCode.typeNumber);
                dataScale = ((_c = (_b = this.options.components) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.scale) || defaultScale;
                dataXyOffset = (1 - dataScale) * 0.5;

                for (row = 0; row < nCount; row++) {
                  for (col = 0; col < nCount; col++) {
                    bIsDark = this.qrCode.isDark(row, col);
                    isBlkPosCtr = col < 8 && (row < 8 || row >= nCount - 8) || col >= nCount - 8 && row < 8;
                    isTiming = row == 6 && col >= 8 && col <= nCount - 8 || col == 6 && row >= 8 && row <= nCount - 8;
                    isProtected = isBlkPosCtr || isTiming;

                    for (_i = 1; _i < alignmentPatternCenters.length - 1; _i++) {
                      isProtected = isProtected || row >= alignmentPatternCenters[_i] - 2 && row <= alignmentPatternCenters[_i] + 2 && col >= alignmentPatternCenters[_i] - 2 && col <= alignmentPatternCenters[_i] + 2;
                    }

                    nLeft = col * nSize + (isProtected ? 0 : dataXyOffset * nSize);
                    nTop = row * nSize + (isProtected ? 0 : dataXyOffset * nSize);
                    mainCanvasContext.strokeStyle = bIsDark ? this.options.colorDark : this.options.colorLight;
                    mainCanvasContext.lineWidth = 0.5;
                    mainCanvasContext.fillStyle = bIsDark ? this.options.colorDark : this.options.colorLight;

                    if (alignmentPatternCenters.length === 0) {
                      if (!isProtected) {
                        mainCanvasContext.fillRect(nLeft, nTop, (isProtected ? isBlkPosCtr ? 1 : 1 : dataScale) * nSize, (isProtected ? isBlkPosCtr ? 1 : 1 : dataScale) * nSize);
                      }
                    } else {
                      inAgnRange = col < nCount - 4 && col >= nCount - 4 - 5 && row < nCount - 4 && row >= nCount - 4 - 5;

                      if (!isProtected && !inAgnRange) {
                        // if align pattern list is empty, then it means that we don't need to leave room for the align patterns
                        mainCanvasContext.fillRect(nLeft, nTop, (isProtected ? isBlkPosCtr ? 1 : 1 : dataScale) * nSize, (isProtected ? isBlkPosCtr ? 1 : 1 : dataScale) * nSize);
                      }
                    }
                  }
                }

                cornerAlignmentCenter = alignmentPatternCenters[alignmentPatternCenters.length - 1]; // - PROTECTORS

                protectorStyle = this.options.colorLight; // - FINDER PROTECTORS

                mainCanvasContext.fillStyle = protectorStyle;
                mainCanvasContext.fillRect(0, 0, 8 * nSize, 8 * nSize);
                mainCanvasContext.fillRect(0, (nCount - 8) * nSize, 8 * nSize, 8 * nSize);
                mainCanvasContext.fillRect((nCount - 8) * nSize, 0, 8 * nSize, 8 * nSize); // - TIMING PROTECTORS

                if ((_e = (_d = this.options.components) === null || _d === void 0 ? void 0 : _d.timing) === null || _e === void 0 ? void 0 : _e.protectors) {
                  mainCanvasContext.fillRect(8 * nSize, 6 * nSize, (nCount - 8 - 8) * nSize, nSize);
                  mainCanvasContext.fillRect(6 * nSize, 8 * nSize, nSize, (nCount - 8 - 8) * nSize);
                } // - CORNER ALIGNMENT PROTECTORS


                if ((_g = (_f = this.options.components) === null || _f === void 0 ? void 0 : _f.cornerAlignment) === null || _g === void 0 ? void 0 : _g.protectors) {
                  AwesomeQR._drawAlignProtector(mainCanvasContext, cornerAlignmentCenter, cornerAlignmentCenter, nSize);
                } // - ALIGNMENT PROTECTORS


                if (!((_j = (_h = this.options.components) === null || _h === void 0 ? void 0 : _h.alignment) === null || _j === void 0 ? void 0 : _j.protectors)) {
                  _context.next = 99;
                  break;
                }

                _i2 = 0;

              case 75:
                if (!(_i2 < alignmentPatternCenters.length)) {
                  _context.next = 99;
                  break;
                }

                j = 0;

              case 77:
                if (!(j < alignmentPatternCenters.length)) {
                  _context.next = 96;
                  break;
                }

                agnX = alignmentPatternCenters[j];
                agnY = alignmentPatternCenters[_i2];

                if (!(agnX === 6 && (agnY === 6 || agnY === cornerAlignmentCenter))) {
                  _context.next = 84;
                  break;
                }

                return _context.abrupt("continue", 93);

              case 84:
                if (!(agnY === 6 && (agnX === 6 || agnX === cornerAlignmentCenter))) {
                  _context.next = 88;
                  break;
                }

                return _context.abrupt("continue", 93);

              case 88:
                if (!(agnX === cornerAlignmentCenter && agnY === cornerAlignmentCenter)) {
                  _context.next = 92;
                  break;
                }

                return _context.abrupt("continue", 93);

              case 92:
                AwesomeQR._drawAlignProtector(mainCanvasContext, agnX, agnY, nSize);

              case 93:
                j++;
                _context.next = 77;
                break;

              case 96:
                _i2++;
                _context.next = 75;
                break;

              case 99:
                // - FINDER
                mainCanvasContext.fillStyle = this.options.colorDark;
                mainCanvasContext.fillRect(0, 0, 7 * nSize, nSize);
                mainCanvasContext.fillRect((nCount - 7) * nSize, 0, 7 * nSize, nSize);
                mainCanvasContext.fillRect(0, 6 * nSize, 7 * nSize, nSize);
                mainCanvasContext.fillRect((nCount - 7) * nSize, 6 * nSize, 7 * nSize, nSize);
                mainCanvasContext.fillRect(0, (nCount - 7) * nSize, 7 * nSize, nSize);
                mainCanvasContext.fillRect(0, (nCount - 7 + 6) * nSize, 7 * nSize, nSize);
                mainCanvasContext.fillRect(0, 0, nSize, 7 * nSize);
                mainCanvasContext.fillRect(6 * nSize, 0, nSize, 7 * nSize);
                mainCanvasContext.fillRect((nCount - 7) * nSize, 0, nSize, 7 * nSize);
                mainCanvasContext.fillRect((nCount - 7 + 6) * nSize, 0, nSize, 7 * nSize);
                mainCanvasContext.fillRect(0, (nCount - 7) * nSize, nSize, 7 * nSize);
                mainCanvasContext.fillRect(6 * nSize, (nCount - 7) * nSize, nSize, 7 * nSize);
                mainCanvasContext.fillRect(2 * nSize, 2 * nSize, 3 * nSize, 3 * nSize);
                mainCanvasContext.fillRect((nCount - 7 + 2) * nSize, 2 * nSize, 3 * nSize, 3 * nSize);
                mainCanvasContext.fillRect(2 * nSize, (nCount - 7 + 2) * nSize, 3 * nSize, 3 * nSize); // - TIMING

                timingScale = ((_l = (_k = this.options.components) === null || _k === void 0 ? void 0 : _k.timing) === null || _l === void 0 ? void 0 : _l.scale) || defaultScale;
                timingXyOffset = (1 - timingScale) * 0.5;

                for (_i3 = 0; _i3 < nCount - 8; _i3 += 2) {
                  AwesomeQR._drawDot(mainCanvasContext, 8 + _i3, 6, nSize, timingXyOffset, timingScale);

                  AwesomeQR._drawDot(mainCanvasContext, 6, 8 + _i3, nSize, timingXyOffset, timingScale);
                } // - CORNER ALIGNMENT PROTECTORS


                cornerAlignmentScale = ((_o = (_m = this.options.components) === null || _m === void 0 ? void 0 : _m.cornerAlignment) === null || _o === void 0 ? void 0 : _o.scale) || defaultScale;
                cornerAlignmentXyOffset = (1 - cornerAlignmentScale) * 0.5;

                AwesomeQR._drawAlign(mainCanvasContext, cornerAlignmentCenter, cornerAlignmentCenter, nSize, cornerAlignmentXyOffset, cornerAlignmentScale, this.options.colorDark, ((_q = (_p = this.options.components) === null || _p === void 0 ? void 0 : _p.cornerAlignment) === null || _q === void 0 ? void 0 : _q.protectors) || false); // - ALIGNEMNT


                alignmentScale = ((_s = (_r = this.options.components) === null || _r === void 0 ? void 0 : _r.alignment) === null || _s === void 0 ? void 0 : _s.scale) || defaultScale;
                alignmentXyOffset = (1 - alignmentScale) * 0.5;
                _i4 = 0;

              case 124:
                if (!(_i4 < alignmentPatternCenters.length)) {
                  _context.next = 148;
                  break;
                }

                _j2 = 0;

              case 126:
                if (!(_j2 < alignmentPatternCenters.length)) {
                  _context.next = 145;
                  break;
                }

                _agnX = alignmentPatternCenters[_j2];
                _agnY = alignmentPatternCenters[_i4];

                if (!(_agnX === 6 && (_agnY === 6 || _agnY === cornerAlignmentCenter))) {
                  _context.next = 133;
                  break;
                }

                return _context.abrupt("continue", 142);

              case 133:
                if (!(_agnY === 6 && (_agnX === 6 || _agnX === cornerAlignmentCenter))) {
                  _context.next = 137;
                  break;
                }

                return _context.abrupt("continue", 142);

              case 137:
                if (!(_agnX === cornerAlignmentCenter && _agnY === cornerAlignmentCenter)) {
                  _context.next = 141;
                  break;
                }

                return _context.abrupt("continue", 142);

              case 141:
                AwesomeQR._drawAlign(mainCanvasContext, _agnX, _agnY, nSize, alignmentXyOffset, alignmentScale, this.options.colorDark, ((_u = (_t = this.options.components) === null || _t === void 0 ? void 0 : _t.alignment) === null || _u === void 0 ? void 0 : _u.protectors) || false);

              case 142:
                _j2++;
                _context.next = 126;
                break;

              case 145:
                _i4++;
                _context.next = 124;
                break;

              case 148:
                // Fill the margin
                if (whiteMargin) {
                  mainCanvasContext.fillStyle = this.options.backgroundColor;
                  mainCanvasContext.fillRect(-margin, -margin, size, margin);
                  mainCanvasContext.fillRect(-margin, viewportSize, size, margin);
                  mainCanvasContext.fillRect(viewportSize, -margin, margin, size);
                  mainCanvasContext.fillRect(-margin, -margin, margin, size);
                }

                if (!this.options.logoImage) {
                  _context.next = 179;
                  break;
                }

                _context.next = 152;
                return loadImage(this.options.logoImage);

              case 152:
                logoImage = _context.sent;
                logoScale = this.options.logoScale;
                logoMargin = this.options.logoMargin;
                logoCornerRadius = this.options.logoCornerRadius;

                if (logoScale <= 0 || logoScale >= 1.0) {
                  logoScale = 0.2;
                }

                if (logoMargin < 0) {
                  logoMargin = 0;
                }

                if (logoCornerRadius < 0) {
                  logoCornerRadius = 0;
                }

                logoSize = viewportSize * logoScale;
                x = 0.5 * (size - logoSize);
                y = x; // Restore the canvas
                // After restoring, the top and left margins should be taken into account

                mainCanvasContext.restore(); // Clean the area that the logo covers (including margins)

                mainCanvasContext.fillStyle = this.options.logoBackgroundColor;
                mainCanvasContext.save();

                AwesomeQR._prepareRoundedCornerClip(mainCanvasContext, x - logoMargin, y - logoMargin, logoSize + 2 * logoMargin, logoSize + 2 * logoMargin, logoCornerRadius + logoMargin);

                mainCanvasContext.clip();
                oldGlobalCompositeOperation = mainCanvasContext.globalCompositeOperation;
                mainCanvasContext.globalCompositeOperation = "destination-out";
                mainCanvasContext.fill();
                mainCanvasContext.globalCompositeOperation = oldGlobalCompositeOperation;
                mainCanvasContext.restore(); // Draw logo image

                mainCanvasContext.save();

                AwesomeQR._prepareRoundedCornerClip(mainCanvasContext, x, y, logoSize, logoSize, logoCornerRadius);

                mainCanvasContext.clip();
                mainCanvasContext.drawImage(logoImage, x, y, logoSize, logoSize);
                mainCanvasContext.restore(); // Re-translate the canvas to translate the top and left margins into invisible area

                mainCanvasContext.save();
                mainCanvasContext.translate(margin, margin);

              case 179:
                if (!parsedGIFBackground) {
                  _context.next = 191;
                  break;
                }

                // Reuse in order to apply the patch
                gifFrames.forEach(function (frame) {
                  if (!gifOutput) {
                    gifOutput = new GIFEncoder(rawSize, rawSize);
                    gifOutput.setDelay(frame.delay);
                    gifOutput.setRepeat(0);
                  }

                  var _frame$dims = frame.dims,
                      width = _frame$dims.width,
                      height = _frame$dims.height;

                  if (!_backgroundCanvas) {
                    _backgroundCanvas = createCanvas(width, height);
                    _backgroundCanvasContext = _backgroundCanvas.getContext("2d");

                    _backgroundCanvasContext.rect(0, 0, _backgroundCanvas.width, _backgroundCanvas.height);

                    _backgroundCanvasContext.fillStyle = "#ffffff";

                    _backgroundCanvasContext.fill();
                  }

                  if (!patchCanvas || !patchData || width !== patchCanvas.width || height !== patchCanvas.height) {
                    patchCanvas = createCanvas(width, height);
                    patchCanvasContext = patchCanvas.getContext("2d");
                    patchData = patchCanvasContext.createImageData(width, height);
                  }

                  patchData.data.set(frame.patch);
                  patchCanvasContext.putImageData(patchData, 0, 0);

                  _backgroundCanvasContext.drawImage(patchCanvas, frame.dims.left, frame.dims.top);

                  var unscaledCanvas = createCanvas(size, size);
                  var unscaledCanvasContext = unscaledCanvas.getContext("2d");
                  unscaledCanvasContext.drawImage(_backgroundCanvas, 0, 0, size, size);
                  unscaledCanvasContext.rect(0, 0, size, size);
                  unscaledCanvasContext.fillStyle = backgroundDimming;
                  unscaledCanvasContext.fill();
                  unscaledCanvasContext.drawImage(mainCanvas, 0, 0, size, size); // Scale the final image

                  var outCanvas = createCanvas(rawSize, rawSize);
                  var outCanvasContext = outCanvas.getContext("2d");
                  outCanvasContext.drawImage(unscaledCanvas, 0, 0, rawSize, rawSize);
                  gifOutput.addFrame(outCanvasContext.getImageData(0, 0, outCanvas.width, outCanvas.height).data);
                });

                if (gifOutput) {
                  _context.next = 183;
                  break;
                }

                throw new Error("No frames.");

              case 183:
                gifOutput.finish();

                if (!isElement(this.canvas)) {
                  _context.next = 188;
                  break;
                }

                u8array = gifOutput.stream().toFlattenUint8Array();
                binary = u8array.reduce(function (bin, u8) {
                  return bin + String.fromCharCode(u8);
                }, "");
                return _context.abrupt("return", Promise.resolve("data:image/gif;base64,".concat(window.btoa(binary))));

              case 188:
                return _context.abrupt("return", Promise.resolve(Buffer.from(gifOutput.stream().toFlattenUint8Array())));

              case 191:
                // Swap and merge the foreground and the background
                backgroundCanvasContext.drawImage(mainCanvas, 0, 0, size, size);
                mainCanvasContext.drawImage(backgroundCanvas, -margin, -margin, size, size); // Scale the final image

                outCanvas = createCanvas(rawSize, rawSize); //document.createElement("canvas");

                outCanvasContext = outCanvas.getContext("2d");
                outCanvasContext.drawImage(mainCanvas, 0, 0, rawSize, rawSize);
                this.canvas = outCanvas;

                if (!isElement(this.canvas)) {
                  _context.next = 199;
                  break;
                }

                return _context.abrupt("return", Promise.resolve(this.canvas.toDataURL()));

              case 199:
                return _context.abrupt("return", Promise.resolve(this.canvas.toBuffer()));

              case 200:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }], [{
    key: "_prepareRoundedCornerClip",
    value: function _prepareRoundedCornerClip(canvasContext, x, y, w, h, r) {
      canvasContext.beginPath();
      canvasContext.moveTo(x, y);
      canvasContext.arcTo(x + w, y, x + w, y + h, r);
      canvasContext.arcTo(x + w, y + h, x, y + h, r);
      canvasContext.arcTo(x, y + h, x, y, r);
      canvasContext.arcTo(x, y, x + w, y, r);
      canvasContext.closePath();
    }
  }, {
    key: "_getAverageRGB",
    value: function _getAverageRGB(image) {
      var blockSize = 5;
      var defaultRGB = {
        r: 0,
        g: 0,
        b: 0
      };
      var width, height;
      var i = -4;
      var rgb = {
        r: 0,
        g: 0,
        b: 0
      };
      var count = 0;
      height = image.naturalHeight || image.height;
      width = image.naturalWidth || image.width;
      var canvas = createCanvas(width, height);
      var context = canvas.getContext("2d");

      if (!context) {
        return defaultRGB;
      }

      context.drawImage(image, 0, 0);
      var data;

      try {
        data = context.getImageData(0, 0, width, height);
      } catch (e) {
        return defaultRGB;
      }

      while ((i += blockSize * 4) < data.data.length) {
        if (data.data[i] > 200 || data.data[i + 1] > 200 || data.data[i + 2] > 200) continue;
        ++count;
        rgb.r += data.data[i];
        rgb.g += data.data[i + 1];
        rgb.b += data.data[i + 2];
      }

      rgb.r = ~~(rgb.r / count);
      rgb.g = ~~(rgb.g / count);
      rgb.b = ~~(rgb.b / count);
      return rgb;
    }
  }, {
    key: "_drawDot",
    value: function _drawDot(canvasContext, centerX, centerY, nSize) {
      var xyOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var dotScale = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
      canvasContext.fillRect((centerX + xyOffset) * nSize, (centerY + xyOffset) * nSize, dotScale * nSize, dotScale * nSize);
    }
  }, {
    key: "_drawAlignProtector",
    value: function _drawAlignProtector(canvasContext, centerX, centerY, nSize) {
      canvasContext.clearRect((centerX - 2) * nSize, (centerY - 2) * nSize, 5 * nSize, 5 * nSize);
      canvasContext.fillRect((centerX - 2) * nSize, (centerY - 2) * nSize, 5 * nSize, 5 * nSize);
    }
  }, {
    key: "_drawAlign",
    value: function _drawAlign(canvasContext, centerX, centerY, nSize) {
      var xyOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var dotScale = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 1;
      var colorDark = arguments.length > 6 ? arguments[6] : undefined;
      var hasProtector = arguments.length > 7 ? arguments[7] : undefined;
      var oldFillStyle = canvasContext.fillStyle;
      canvasContext.fillStyle = colorDark;
      new Array(4).fill(0).map(function (_, i) {
        AwesomeQR._drawDot(canvasContext, centerX - 2 + i, centerY - 2, nSize, xyOffset, dotScale);

        AwesomeQR._drawDot(canvasContext, centerX + 2, centerY - 2 + i, nSize, xyOffset, dotScale);

        AwesomeQR._drawDot(canvasContext, centerX + 2 - i, centerY + 2, nSize, xyOffset, dotScale);

        AwesomeQR._drawDot(canvasContext, centerX - 2, centerY + 2 - i, nSize, xyOffset, dotScale);
      });

      AwesomeQR._drawDot(canvasContext, centerX, centerY, nSize, xyOffset, dotScale);

      if (!hasProtector) {
        canvasContext.fillStyle = "rgba(255, 255, 255, 0.6)";
        new Array(2).fill(0).map(function (_, i) {
          AwesomeQR._drawDot(canvasContext, centerX - 1 + i, centerY - 1, nSize, xyOffset, dotScale);

          AwesomeQR._drawDot(canvasContext, centerX + 1, centerY - 1 + i, nSize, xyOffset, dotScale);

          AwesomeQR._drawDot(canvasContext, centerX + 1 - i, centerY + 1, nSize, xyOffset, dotScale);

          AwesomeQR._drawDot(canvasContext, centerX - 1, centerY + 1 - i, nSize, xyOffset, dotScale);
        });
      }

      canvasContext.fillStyle = oldFillStyle;
    }
  }]);

  return AwesomeQR;
}();
AwesomeQR.CorrectLevel = QRErrorCorrectLevel;
AwesomeQR.defaultComponentOptions = {
  data: {
    scale: 0.4
  },
  timing: {
    scale: 0.5,
    protectors: false
  },
  alignment: {
    scale: 0.5,
    protectors: false
  },
  cornerAlignment: {
    scale: 0.5,
    protectors: true
  }
};
AwesomeQR.defaultOptions = {
  text: "",
  size: 400,
  margin: 20,
  colorDark: "#000000",
  colorLight: "rgba(255, 255, 255, 0.6)",
  correctLevel: QRErrorCorrectLevel.M,
  backgroundImage: undefined,
  backgroundDimming: "rgba(0,0,0,0)",
  logoImage: undefined,
  logoScale: 0.2,
  logoMargin: 4,
  logoCornerRadius: 8,
  whiteMargin: true,
  components: AwesomeQR.defaultComponentOptions,
  autoColor: true,
  logoBackgroundColor: '#ffffff',
  backgroundColor: '#ffffff'
};

function isElement(obj) {
  try {
    //Using W3 DOM2 (works for FF, Opera and Chrome)
    return obj instanceof HTMLElement;
  } catch (e) {
    //Browsers not supporting W3 DOM2 don't have HTMLElement and
    //an exception is thrown and we end up here. Testing some
    //properties that all elements have (works on IE7)
    return _typeof(obj) === "object" && obj.nodeType === 1 && _typeof(obj.style) === "object" && _typeof(obj.ownerDocument) === "object";
  }
}